export default __webpack_public_path__ + "static/media/ban-mobile-image-7.7e28f971.jpg";